import { render, staticRenderFns } from "./userClient.vue?vue&type=template&id=0c9d3d3b&"
import script from "./userClient.vue?vue&type=script&lang=js&"
export * from "./userClient.vue?vue&type=script&lang=js&"
import style0 from "./userClient.vue?vue&type=style&index=0&id=0c9d3d3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports